import { api } from "apiServer"
import { Layout } from "components/common"
import { Fragment, useEffect, useRef, useState } from "react"
import { getAccessToken } from "lib/Cookies"
import CardLeague from "components/CardLeague"
let calling = false

function Component({ lists, slug }) {
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState(lists)
  const pageNum = useRef(1)
  const maxCount = useRef(50)
  const [loadingCard, setLoadingCard] = useState(true)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 640) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setLoadingCard(false)
    }, 2000)
  }, [])

  useEffect(() => {
    function onScroll() {
      if (window.scrollY + window.innerHeight > (document.body.scrollHeight * 6) / 7) {
        if (!calling) {
          setLoading(true)
        }
      }
    }

    window.addEventListener("scroll", onScroll)
    return () => {
      window.removeEventListener("scroll", onScroll)
    }
  }, [])

  async function fetch() {
    try {
      pageNum.current = pageNum.current + 1
      const { data, count } = await api.getSeemoreLeagues(getAccessToken(), {
        page_num: pageNum.current,
        page_size: 24
      })
      maxCount.current = count
      setRows([...rows, ...data])
    } catch (error) {
      console.log(error.response)
    } finally {
      setLoading(false)
      calling = false
    }
  }

  useEffect(() => {
    if (loading && maxCount.current > rows.length) fetch()
  }, [loading])

  return (
    <div
      className={
        "flex flex-col gap-8 mb-8 max-lg:gap-4 max-sm:gap-4 max-lg:mx-4 max-lg:mt-5 max-sm:mx-0 xl:mr-8 md:mx-4" +
        (isMobile ? " px-4" : "")
      }
    >
      <div className="flex gap-3">
        <div className="text-[26px] leading-[30px] text-[#fafaf9] font-semibold max-sm:text-[20px]">Giải đấu</div>
      </div>
      <div
        className={
          !isMobile
            ? "grid grid-cols-3 2xl:grid-cols-4 gap-y-5 gap-x-6 place-items-center max-lg:grid-cols-2 max-lg:gap-x-3 "
            : "flex flex-col gap-3"
        }
      >
        {rows?.length > 0 &&
          rows?.map((item) => {
            const { id } = item
            return (
              <Fragment key={id}>
                <CardLeague {...item} />
              </Fragment>
            )
          })}
      </div>
    </div>
  )
}

export default Component
Component.Layout = Layout

export async function getServerSideProps({ req, res }) {
  res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=29")
  let lists = []
  const { cookies } = req
  try {
    const { data, success } = await api.getSeemoreLeagues(cookies?.accessToken)
    if (success) lists = data
  } catch (error) {
    console.log(error.response)
  }
  return { props: { lists } }
}
